<div *ngIf="(stepSideTmpl$ | async) != null && sws.activeStep$ | async as step" class="wizard a-fx" @parent>
    <div *ngIf="stepSideTmpl$ | async as stepSide" class="wizard-side a-fx a-fx-center-center">
        <div @widthAnimate>
            <ng-container *ngTemplateOutlet="stepSide"></ng-container>
        </div>
    </div>

    <div class="wizard-container a-fx-col a-fx-gap-16 a-fx-flex" [style.max-width.px]="step.maxWidth || 1920">
        <div class="a-fx a-fx-between-center a-fx-gap-32 a-fx-none">
            <div class="h1">
                <ng-container *ngIf="step.header || (step.useTitleAsHeader && step.title) as header; else title?.tr">
                    {{ header }}
                </ng-container>
            </div>

            <div class="a-fx a-fx-start-center a-fx-gap-40">
                <adspt-step-wizard-stepper></adspt-step-wizard-stepper>

                <button nz-button class="wizard-close" tabIndex="-1" (click)="sws.close$.next(false)">
                    <i nz-icon>
                        <svg class="adspt-icon">
                            <use xlink:href="#adspt-cross"></use>
                        </svg>
                    </i>
                </button>
            </div>
        </div>

        <div class="wizard-step a-fx-col a-fx-flex">
            <div class="a-fx-flex">
                <ng-container *ngTemplateOutlet="step.tr"></ng-container>
            </div>

            <div class="wizard-actions a-fx a-fx-end-center a-fx-gap-16 a-fx-none">
                <button
                    *ngIf="sws.isFirstStep$ | async; else backButtonTmpl"
                    class="a-fx-none"
                    nz-button
                    [adsptHeap]="(heapPrefix ? heapPrefix + '-' : '') + 'wizard-cancel'"
                    [heapData]="{ index: sws.activeIdx$ | async }"
                    (click)="sws.close$.next(false)"
                >
                    {{ 'common.cancel' | translate }}
                </button>

                <ng-template #backButtonTmpl>
                    <button
                        *ngIf="!step.final"
                        class="a-fx-none"
                        nz-button
                        [adsptHeap]="(heapPrefix ? heapPrefix + '-' : '') + 'wizard-back'"
                        [heapData]="{ index: sws.activeIdx$ | async }"
                        (click)="sws.stepBack()"
                    >
                        {{ 'common.back' | translate }}
                    </button>
                </ng-template>

                <button
                    *ngIf="sws.isLastStep$ | async; else nextButtonTmpl"
                    class="a-fx-none"
                    nz-button
                    nzType="primary"
                    [disabled]="step.canContinue === false"
                    [adsptHeap]="(heapPrefix ? heapPrefix + '-' : '') + 'wizard-save'"
                    (click)="sws.saveAndClose()"
                >
                    {{ step.primaryButton || ('common.save-changes' | translate) }}
                </button>

                <ng-template #nextButtonTmpl>
                    <button
                        class="a-fx-none"
                        nz-button
                        nzType="primary"
                        [disabled]="step.canContinue === false"
                        [adsptHeap]="(heapPrefix ? heapPrefix + '-' : '') + 'wizard-next'"
                        [heapData]="{ index: sws.activeIdx$ | async }"
                        [nzLoading]="sws.asserting$ | async"
                        (click)="sws.stepForward()"
                    >
                        {{ step.primaryButton || ('common.next' | translate) }}
                    </button>
                </ng-template>
            </div>
        </div>
    </div>
</div>
